import Vue from 'vue';
import moment from 'moment';

export default {
  methods: {
    showToasterError(error) {
      if (error && error.response && error.response.data) {
        const errorMsg = error.response.data.errors ? error.response.data.errors : error.response.data.msg;
        if (typeof errorMsg === 'object') {
          for (const key in errorMsg) {
            if (errorMsg.hasOwnProperty(key)) {
              toastr.error(errorMsg[key]);
            }
          }
        } else if (typeof errorMsg === 'string') {
          toastr.error(errorMsg);
        }
      }
    },
    openModal(selector) {
      $(selector).addClass('show');
      $('body').addClass('modal-open');
      $('body').append('<div class="modal-backdrop fade show"></div>');
      $('.modal-content').css({ display: 'block' });
    },
    closeModal(selector) {
      $(selector).find('input').val('');
      $(selector).removeClass('show');
      $('body').removeClass('modal-open');
      $('div.modal-backdrop.fade.show').remove();
    },
    closeModalKeepValue(selector) {
      $(selector).removeClass('show');
      $('body').removeClass('modal-open');
      $('div.modal-backdrop.fade.show').remove();
    },
    changeLang(lang) {
      Vue.config.lang = lang;
    },
    generateDownloadableCSVLink(csv, filename) {
      let csvFile;
      let downloadLink;

          // CSV FILE
      csvFile = new Blob([csv], { type: 'text/csv' });
          // Download link
      downloadLink = document.createElement('a');
          // File name
      downloadLink.download = filename;
          // We have to create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);
          // Make sure that the link is not displayed
      downloadLink.style.display = 'none';
          // Add the link to your DOM
      document.body.appendChild(downloadLink);
          // Lanzamos
      downloadLink.click();
    },
    checkUserTimeZone(context, checkin, checkout) {
      const offset = new Date().getTimezoneOffset();
      if (offset > 0) {
        context.checkinDate = moment(checkin).add(1, 'days').format('YYYY-MM-DD');
        context.checkoutDate = moment(checkout).add(1, 'days').format('YYYY-MM-DD');
      } else {
        context.checkinDate = moment(checkin).format('YYYY-MM-DD');
        context.checkoutDate = moment(checkout).format('YYYY-MM-DD');
      }
    },
    checkAccessToTabs(context) {
      if (context.user.is_team_member) {
        if (context.user.rights) {
          context.user.rights.forEach((right) => {
            if (right.analytics) {
              if (right.analytics_general === 1) {
                context.accessToTabsStatus.general = true;
              }
              if (right.analytics_rentals === 1) {
                context.accessToTabsStatus.rentals = true;
              }
              if (right.analytics_reviews === 1) {
                context.accessToTabsStatus.reviews = true;
              }
              if (right.analytics_environment === 1) {
                context.accessToTabsStatus.environment = true;
              }
              if (right.analytics_market === 1) {
                context.accessToTabsStatus.market = true;
              }
            }
          });
        }
      } else if (context.user && !context.user.is_team_member) {
        context.accessToTabsStatus.general = true;
        context.accessToTabsStatus.rentals = true;
        context.accessToTabsStatus.reviews = true;
        context.accessToTabsStatus.environment = true;
        context.accessToTabsStatus.market = true;
      }
    },
    replaceCustomShortCodes(content, rentalId) {
      let rentalShortCode = '';
      let shortCodeContent = '';
      const customShortCodes = this.shortCodes;
      let code = '';
      customShortCodes.map((shortCode) => {
        shortCodeContent = shortCode.content;
        if (rentalId && shortCode.rentals) {
          rentalShortCode = shortCode.rentals.find(rental => rental.pivot.rental_id === rentalId);
          if (rentalShortCode && rentalShortCode.pivot && rentalShortCode.pivot.short_code_text) {
            shortCodeContent = rentalShortCode.pivot.short_code_text;
          }
        }
        code = shortCode.code;
        code = new RegExp(`\\${code}`, 'g');
        content = content.replace(code, shortCodeContent);
      });
      return content;
    },
    getBookingChannelName(channel, originalReferrer, ical) {
      if (ical) {
        return ical.name;
      }
      return channel && channel.name ? `${channel.name} ${originalReferrer || ''}` : 'Direct';
    },
    getTriggerTimeName(triggerTime, occurName, days, airbnb = false) {
      if (occurName == 'after-booking' ||
            occurName == 'after-checkin' ||
            occurName == 'after-checkout' ||
            occurName == 'before-checkout' ||
            occurName == 'before-checkin' ||
            occurName == 'after-payment-view' ||
            occurName == 'after-payment-link-ko' ||
            occurName == 'after-deposit-link-ko') {
        if (triggerTime) {
          const explodedTime = triggerTime.toString().split(' ');
          if (explodedTime[1]) {
            if (days.includes(explodedTime[1])) {
                  // trigger time is hour
              const number = Number(explodedTime[0]);
              if (number > 1) {
                return `${number} ${this.$t('automation.index.trigger_time_names.hours')}`;
              }
              return `${number} ${this.$t('automation.index.trigger_time_names.hour')}`;
            }
                // trigger time is day
            let number = Number(explodedTime[0]);
            if (airbnb) {
              number -= 1;
            }
            if (number > 1) {
              return `${number} ${this.$t('automation.index.trigger_time_names.days')}`;
            }
            return `${number} ${this.$t('automation.index.trigger_time_names.day')}`;
          } else if (airbnb) {
            let number = Number(explodedTime[0]);
            if (airbnb) {
              number -= 1;
            }
            if (number > 1) {
              return `${number} ${this.$t('automation.index.trigger_time_names.days')}`;
            }
            return `${number} ${this.$t('automation.index.trigger_time_names.day')}`;
          }
        }
      } else if (occurName === 'specific-day') {
        moment.locale('fr', {
          months: this.$t('months'),
          weekdaysShort: this.$t('medWeekDays'),
          monthsShort: this.$t('shortMonths'),
        });
        if (triggerTime.includes('-')) {
          return moment(triggerTime).format('ddd DD MMMM YYYY HH:mm:ss');
        }
        return triggerTime;
      } else {
        return triggerTime;
      }
    },
    openEditableModal(selector, name, link) {
      $(selector).addClass('show');
      $('body').addClass('modal-open');
      $('body').append('<div class="modal-backdrop fade show"></div>');
      $('.modal-content').css({ display: 'block' });
      $('#other-platform-name').val(name);
      $('#other-platform-link').val(link);
    },
    getReservationStatusName(reservationStatusId) {
      reservationStatusId = parseInt(reservationStatusId);
      if (reservationStatusId === 1) {
        return this.$t('calendar.booking-detail.new_status');
      } else if (reservationStatusId === 2) {
        return this.$t('calendar.booking-detail.modified_status');
      }
      return this.$t('calendar.booking-detail.cancelled_status');
    },
    getPriceAmount(booking) {
      const price = booking.price && !isNaN(booking.price) ? parseFloat(booking.price) : 0;
      const cityTaxes = Number(booking.city_taxes);
      const cleaningFee = Number(booking.cleaning);
      const otherTaxes = booking.other_taxes ? booking.other_taxes : 0;
      const serviceCharges = booking.service_charges ? booking.service_charges : 0;
      const otherCharges = booking.other_charges ? booking.other_charges : 0;
      return parseFloat((cleaningFee + price + booking.price_extra + cityTaxes + otherTaxes + serviceCharges + otherCharges).toFixed(2));
    },
    getBookingStatusName(id, code, done) {
      done = parseInt(done, 10);
      code = parseInt(code, 10);
      if (done === 1 && id === 1) {
        return this.$t('booking.index.status.confirmed');
      }
      if (id === 1 && code === 12) {
        return this.$t('booking.index.status.confirmed');
      } else if (id === 0 && code === 20) {
        return this.$t('booking.detail.status.refunded');
      } else if (id === 0) {
        return this.$t('booking.index.status.cancelled');
      } else if (id === 3) {
        return this.$t('booking.index.status.no_show');
      } else if (id === 4) {
        return this.$t('booking.index.status.request');
      } else if (id === 5) {
        return this.$t('booking.index.status.cancelled_by_traveler');
      }
      return this.$t('booking.index.status.not_confirmed');
    },
    getBookingCleaningVideoLink(bookingEvents) {
      const cleaningEvent = bookingEvents.find(bookingEvent => bookingEvent.checklist_group_type.name === 'Cleaning');
      if (cleaningEvent && cleaningEvent.videos && cleaningEvent.videos.length > 0) {
        return cleaningEvent.videos[0].name;
      }
      return '';
    },
    getDatesNotAvailable(dates, type) {
      const newDates = [];
      if (Object.keys(dates).length > 0) {
        Object.values(dates).map((date) => {
          let fromDate = moment(date.startDate);
          let toDate = moment(date.endDate);
          if (type === 'checkout' && !Object.values(dates).find(d => moment(d.endDate).format('YYYY-MM-DD') === fromDate.format('YYYY-MM-DD'))) {
            fromDate = fromDate.add(1, 'days');
          } else if (type === 'checking' && !Object.values(dates).find(d => moment(d.startDate).format('YYYY-MM-DD') === toDate.format('YYYY-MM-DD'))) {
            toDate = toDate.subtract(1, 'days');
          }
          const diffDays = toDate.diff(fromDate, 'days');
          for (let index = 0; index <= diffDays; index++) {
            const year = moment(fromDate).add(index, 'days').year();
            const month = moment(fromDate).add(index, 'days').month();
            const day = moment(fromDate).add(index, 'days').date();
            newDates.push(moment.utc([year, month, day]).toDate());
          }
        });
      }

      return newDates;
    },
    parseAndRound(amount, digits = 2) {
      return Number(parseFloat(amount).toFixed(digits));
    },
    hideDisabledWarning() {
      $('.cancel').removeClass('disabled');
      $('.confirm').removeClass('disabled');
    },
    closePanelOverlay() {
      $('.panel-overlay').fadeOut();
    },
    getBookingPartPrice(price, cleaning, cityTaxes, percent) {
      const amount = ((price + cleaning + cityTaxes) * percent / 100);
      return Number(parseFloat(amount).toFixed(2));
    },
    createTextLinks(text) {
      const matchedTags = text.match(/href="([^\'\"]+)/g) ? text.match(/href="([^\'\"]+)/g) : [];
      const matchedLinks = text.match(/(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/ig);
      let links = [];
      if (matchedLinks) {
        matchedLinks.map((link) => {
          if (matchedTags.length) {
            matchedTags.map((m) => {
              if (!m.includes(link)) {
                links = [...links, link];
              }
            });
          } else {
            links = matchedLinks;
          }
        });
      }
          // Make links of array unique
      const uniqueLinks = links.filter((c, index) => links.indexOf(c) === index);
      let editedText = text;

      uniqueLinks.map((link) => {
        editedText = editedText.replaceAll(
            link, `<a href="${link}" target="_blank">${link}</a>`);
      });

      return editedText;
    },
    returnBack() {
      this.$router.go(-1);
    },
    getBookingExtraDetails(extraDataForm, type = 'notes') {
      if (extraDataForm) {
        return extraDataForm[type] ? extraDataForm[type] : '-';
      }

      return '-';
    },
    isExtraDataLong(extraDataForm, type = 'notes') {
      return this.getBookingExtraDetails(extraDataForm, type).length > 39;
    },
    getBookingUrl(booking, rental) {
      let url = null;
      switch (booking.channel_id) {
        case 1:
          url = booking.message_thread_id ? `https://www.airbnb.fr/hosting/inbox/folder/all/thread/${booking.message_thread_id}/details` : null;
          break;
        case 2:
          url = rental.booking_hotel_id && booking.booking_com_res_id
                ?
                `https://admin.booking.com/hotel/hoteladmin/extranet_ng/manage/booking.html?lang=fr&hotel_id=${rental.booking_hotel_id}&res_id=${booking.booking_com_res_id}`
                :
                null;

          break;
      }

      return url;
    },
    getErrorMessage(error) {
      let text = '';
      if (error.message) {
        if (error.message.match(/A network error has occurred/)) {
          text = this.$t('payments.permalink.errors.network_error');
        } else if (error.message.match(/Your card number is incorrect/)) {
          text = this.$t('payments.permalink.errors.card_number_incorrect');
        } else if (error.message.match(/Expired API Key/)) {
          text = this.$t('payments.permalink.errors.expired_api_key');
        } else if (error.message.match(/Your card's expiration year is invalid/)) {
          text = this.$t('payments.permalink.errors.exp_year');
        } else {
          text = error.message;
        }
      } else {
        text = vm.$t('payments.permalink.errors.contact_support');
      }
      return text;
    },
    addClipboard(className, btn, context) {
      if (context.clipboardBtnCopyFormLink) {
        context.clipboardBtnCopyFormLink.destroy();
      }

      context[btn] = new Clipboard(className);

      context[btn].on('success', (e) => {
        e.clearSelection();
        toastr.success(context.$t('booking.detail.action.copied'));
      });

      context[btn].on('error', (e) => {
        e.clearSelection();
        toastr.success(context.$t('booking.detail.action.not_copied'));
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/mixin.js